import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Select, Space, Tag } from "antd";
import { useEffect, useMemo, useState } from "react";
import { EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useServiceCdnState } from "../../../../../../../hooks/service/useServiceCdnState.js";
import { useTranslation } from "../../../../../../../others/i18n.js";
import { getDataProcessingInSelectOptions } from "../../../../../../../util/template/data-processing-in.js";
import { getDisableStrategies } from "../../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateDataProcessingInCountries() {
    const { t } = useTranslation();
    // available countries
    const countryGroups = useMemo(()=>{
        return getDataProcessingInSelectOptions(t);
    }, []);
    const cdnFieldState = useServiceCdnState();
    const [isRequired, setIsRequired] = useState(false);
    const [rules, setRules] = useState([]);
    useEffect(()=>{
        if (cdnFieldState !== "disabled") {
            setIsRequired(true);
            setRules([
                {
                    type: "array",
                    min: 1,
                    required: true,
                    message: t("Please select at least one country")
                }
            ]);
        } else {
            setIsRequired(false);
            setRules([]);
        }
    }, [
        cdnFieldState
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.DataProcessingInCountries,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ServiceTemplateField.DataProcessingInCountries, t),
            extra: t("Data is usually processed in the countries where the service has its headquarter or servers."),
            required: isRequired,
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ServiceTemplateField.DataProcessingInCountries,
                    disableStrategies: getDisableStrategies(true),
                    onKeepContent: extended && extended[ServiceTemplateField.DataProcessingInCountries] && /*#__PURE__*/ _jsx(Space, {
                        size: [
                            8,
                            8
                        ],
                        wrap: true,
                        children: extended[ServiceTemplateField.DataProcessingInCountries]?.map((country)=>{
                            return countryGroups.map((group)=>group.options).flat().find((option)=>option.value === country);
                        }).map((option)=>/*#__PURE__*/ _jsx(Tag, {
                                color: "grey",
                                children: option.label
                            }, `extended-processing-in-${option.value}`))
                    }),
                    children: /*#__PURE__*/ _jsx(Form.Item, {
                        name: ServiceTemplateField.DataProcessingInCountries,
                        noStyle: true,
                        rules: rules,
                        children: /*#__PURE__*/ _jsx(Select, {
                            mode: "multiple",
                            placeholder: t("Select countries ..."),
                            options: countryGroups,
                            style: {
                                width: "100%"
                            },
                            allowClear: true,
                            optionFilterProp: "label"
                        })
                    })
                });
            }
        })
    });
}
export { FormFieldServiceTemplateDataProcessingInCountries };
